import { BoardStatus } from "./board-status.model";

export interface BoardResponse {
  boardStatuses: BoardStatus[];
}

